import { render } from "./DomainsDonutChart.vue?vue&type=template&id=0223b51d&scoped=true"
import script from "./DomainsDonutChart.vue?vue&type=script&lang=js"
export * from "./DomainsDonutChart.vue?vue&type=script&lang=js"

import "./DomainsDonutChart.vue?vue&type=style&index=0&id=0223b51d&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0223b51d"]])

export default __exports__